import gsap from "gsap";


(function ($) {
    let target = $(".merch")

    function randomInteger(min, max) {
        let rand = min + Math.random() * (max + 1 - min);
        rand = Math.floor(rand);
        return rand;
    }

    function setDelay() {
        let random = randomInteger(0, 2);
        let current_slide = $('.merch .item').eq(random);

        gsap.to(current_slide, 0.4,
            {
                y: 40,
                opacity: 0,
                ease: "power1"
            }
        );
        setTimeout(function () {
            current_slide.toggleClass('hideSlide showSlide');

            let next_current_slide = target.find(".item").eq(3);
            next_current_slide.insertAfter(target.find(".item").eq(random));
            next_current_slide.toggleClass('hideSlide showSlide ');

            gsap.fromTo(next_current_slide, 0.4, {
                y: 40,
                opacity: 0,
                ease: "power1"
            },
                {
                    y: 0,
                    opacity: 1,
                    ease: "power1"
                });
            current_slide.insertAfter(target.find(".item").last());

        }, 800);
    }

    let timerId = setInterval(function () {
        setDelay();
    }, 3000);

})(jQuery);